import { defineComponent, PropType } from 'vue';
import { logger } from '_c/util/logger';

const tag = 'KK-Image';

const fitArray: string[] = [
  'cover',
  'fill',
  'contain',
  'none',
];
const cdnDomains: Array<RegExp> = [
  /^https?:\/\/static.gameplus.qq.com/,
  /^https?:\/\/test-static.gameplus.qq.com/,
  /^https?:\/\/knock-test.gtimg.com/,
  /^https?:\/\/knock.gtimg.com/,
  /^https?:\/\/knock-user-1300342587/,
];

const sizeRange: Array<number> = [80, 160, 320, 480, 640, 720, 800, 1080, 1440];

export default defineComponent({
  props: {
    src: {
      type: String as PropType<string>,
      required: true,
    },
    width: {
      type: Number as PropType<number>,
      default: 0,
    },
    height: {
      type: Number as PropType<number>,
      default: 0,
    },
    fit: {
      type: String as PropType<string>,
      default: 'cover',
    },
  },

  emits: ['click'],

  /// 未使用，暂时去掉
  // data() {
  //   return {
  //     status: 'init',
  //   };
  // },

  computed: {
    imageContainerStyle(): Record<string, string> {
      if (this.width === 0 && this.height === 0) {
        return { width: '100%', height: '100%' };
      }
      return { width: `${this.width}px`, height: `${this.height}px` };
    },

    requestSrc(): string {
      if (this.canReduce) {
        if (this.width === 0 && this.height === 0) {
          // 默认带数据万像的参数方式，带上这种参数的逻辑会允许我们的后台配置一个被打击时的错误图像，只对没有任何参数的URL生效
          return `${this.src}?imageMogr2/`;
        }
        /** /ignore-error/1 参数  数据万象处理不了的图片 会返回原图*/
        // 按宽度裁剪
        if (this.width > 0) {
          return `${this.src}?imageView2/2/w/${this.getSize(this.width)}/ignore-error/1`;
        }
        // 按高度裁剪
        return `${this.src}?imageView2/2/h/${this.getSize(this.height)}/ignore-error/1`;
      }
      return this.src;
    },

    canReduce(): boolean {
      const { length } = cdnDomains;
      for (let i = 0; i < length; i++) {
        if (cdnDomains[i].test(this.src)) {
          return true;
        }
      }
      return false;
    },

    objectFit(): string {
      if (-1 !== fitArray.indexOf(this.fit)) {
        return this.fit;
      }
      return fitArray[0];
    },
  },

  watch: {
    src() {
      this.loadImage();
    },
  },

  mounted() {
    this.loadImage();
  },

  methods: {
    loadImage() {
      // todo 图片加载、错误兜底
      const image = new Image(); // 新建一个img标签（还没嵌入DOM节点)
      image.onload = () => {
        // this.status = 'success';
        const el = this.$refs.box as HTMLElement;
        if (el) {
          el.style.backgroundImage = `url(${this.requestSrc})`;
        }
      };
      image.onerror = () => {
        // this.status = 'error';
        logger.warn(tag, `图片加载失败 src: ${this.src}`);
      };
      image.src = this.requestSrc;
    },

    getSize(size: number): number {
      const len = sizeRange.length;
      for (let i = 0; i < len; i++) {
        if (size <= sizeRange[i]) {
          return sizeRange[i];
        }
      }
      return sizeRange[len - 1];
    },
    clickPic(event: Event) {
      this.$emit('click', event);
    },
  },
});
